import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { setFileversionIdAndNodeOffsetIdMap } from "../reducers/common";
import { HoopsViewerContext, CubeGlobal } from "@Features/viewer-core";
import _ from "lodash";
import { getFileversionIdFromAwsfilename } from "./cubeViewHelper";
import { RootState } from "@Reducers/index";
import { selectFileVersionData } from "@Reducers/fileVersion";

// `fileVersionId` is the viewer's currently-open file version, which is absent when no file is
// mounted; the `filesData` lookups below then miss and the effect skips the mapping fetch.
const useFileVersionIdAndNodeOffsetIdMap = (fileVersionId: string | undefined) => {
  const dispatch = useDispatch();
  const filesData = useSelector((state: RootState) => state.filesData);
  const { isModelStructureReady } = useContext(HoopsViewerContext);

  const [mapper, setMapper] = useState<any>({});

  useEffect(() => {
    const fetchFileVersionMapping = () => {
      const newMapper: any = {};
      const absoluteNode = CubeGlobal.hwv.model.getAbsoluteRootNode();
      const modelFileNodes = CubeGlobal.hwv.model.getNodeChildren(absoluteNode);

      modelFileNodes.forEach((node: any) => {
        const awsFilename = CubeGlobal.hwv.model.getModelFileNameFromNode(node);
        const fileVersionIdFromAws = getFileversionIdFromAwsfilename(awsFilename);
        if (fileVersionIdFromAws) {
          const nodeOffset = CubeGlobal.hwv.model.getNodeIdOffset(node);
          newMapper[fileVersionIdFromAws] = nodeOffset;
        }
      });

      dispatch(setFileversionIdAndNodeOffsetIdMap(newMapper));
      setMapper(newMapper);
    };

    let fileVersions: any[] = [];
    const fileData = selectFileVersionData(filesData, fileVersionId);
    if (fileData && fileData.resourceType == "RESOURCE_TYPE_MERGED_FILE") {
      fileVersions = (fileData.sourceFileVersionId ?? [])
        .filter((file: any) => !file.isDeleted)
        .map((file: any) => file.id);
    } else {
      fileVersions = [fileVersionId];
    }
    if (
      isModelStructureReady &&
      !fileVersions.every((val: any) => Object.hasOwn(mapper, val)) &&
      fileVersions.every((val: any) => Object.hasOwn(filesData, val))
    ) {
      fetchFileVersionMapping();
    }
  }, [fileVersionId, filesData, mapper, isModelStructureReady]);

  return mapper;
};

export default useFileVersionIdAndNodeOffsetIdMap;
